var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCase({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.3335 16.25C3.3335 15.6975 3.55299 15.1676 3.94369 14.7769C4.33439 14.3861 4.8643 14.1667 5.41683 14.1667H16.6668",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.41683 1.66667H16.6668V18.3333H5.41683C4.8643 18.3333 4.33439 18.1138 3.94369 17.7231C3.55299 17.3324 3.3335 16.8025 3.3335 16.25V3.75001C3.3335 3.19747 3.55299 2.66757 3.94369 2.27687C4.33439 1.88617 4.8643 1.66667 5.41683 1.66667V1.66667Z",
    stroke: "#808191",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase);
export default __webpack_public_path__ + "static/media/case.aba1df8ac1db18da10629b1fba86630d.svg";
export { ForwardRef as ReactComponent };